import React, { useState } from "react";
import { Button, Nav, Dropdown } from "react-bootstrap";
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import { useNavigate } from "react-router-dom";
import { 
  FaUserCircle, 
  FaSignOutAlt, 
  FaBook, 
  FaCog, 
  FaChevronDown,
  FaChartLine,
  FaBars,
  FaCalculator
} from 'react-icons/fa';
import 'assets/PortalNavbar.css'; // File CSS untuk styling kustom

const PortalNavbar = (props) => {
    const data = JSON.parse(props.data);
    const navigate = useNavigate();
    const [showDropdown, setShowDropdown] = useState(false);

    const logout = () => {
        localStorage.clear();
        navigate('/auth/login');
    }

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <Button
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
                setShowDropdown(!showDropdown);
            }}
            variant="outline-light"
            className="user-dropdown-toggle d-flex align-items-center"
        >
            {children}
        </Button>
    ));

    return (
        <React.Fragment>
            <Navbar bg="primary" expand="lg" className="modern-navbar" sticky="top">
                <Container fluid>
                    {/* Brand Logo dengan Icon */}
                    <Navbar.Brand href="/" className="brand-logo d-flex align-items-center">
                        <FaChartLine className="brand-icon me-2" />
                        <span className="brand-text">CashFlow Monitor</span>
                        <span className="badge badge-version">v1.0</span>
                    </Navbar.Brand>

                    {/* Mobile Toggle */}
                    <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-0">
                        <FaBars className="text-white" />
                    </Navbar.Toggle>

                    <Navbar.Collapse id="basic-navbar-nav">
                        {/* Main Navigation */}
                        
                        <Nav className="me-auto">
                            {/*
                            <Nav.Link href="/" className="nav-link-custom d-flex align-items-center">
                                <FaHome className="nav-icon me-2" />
                                Dashboard
                            </Nav.Link>
                            <Nav.Link href="/books" className="nav-link-custom d-flex align-items-center">
                                <FaBook className="nav-icon me-2" />
                                Books
                            </Nav.Link>
                            <Nav.Link href="/wallet" className="nav-link-custom d-flex align-items-center">
                                <FaWallet className="nav-icon me-2" />
                                Wallet
                            </Nav.Link>
                            */}
                        </Nav>
                            
                        {/* Right Side Navigation */}
                        <Nav className="align-items-center">
                            {/* Notification Bell */}
                            {/*
                            <Nav.Link className="nav-icon-link position-relative">
                                <FaBell className="nav-icon" />
                                <span className="notification-badge">3</span>
                            </Nav.Link>
                            */}
                            {/* User Dropdown */}
                            <Nav.Link href="/calculator" className="nav-link-custom d-flex align-items-center">
                                <FaCalculator className="nav-icon" />
                                Life Insurance Calculator
                            </Nav.Link>
                            <Dropdown show={showDropdown} onToggle={setShowDropdown} align="end">
                                <Dropdown.Toggle as={CustomToggle}>
                                    <FaUserCircle className="user-avatar me-2" />
                                    <span className="user-name" style={{textTransform:'capitalize', fontWeight:'600'}}>
                                        {data.user_nicename}
                                    </span>
                                    <FaChevronDown className={`dropdown-arrow ms-2 ${showDropdown ? 'rotate' : ''}`} />
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="user-dropdown-menu">
                                    <Dropdown.Header className="dropdown-header">
                                        <div className="d-flex align-items-center">
                                            <FaUserCircle className="dropdown-avatar me-3" />
                                            <div>
                                                <div className="user-name-dropdown" style={{textTransform:'capitalize'}}>
                                                    {data.user_nicename}
                                                </div>
                                                <div className="user-email text-muted small">
                                                    {data.user_email}
                                                </div>
                                            </div>
                                        </div>
                                    </Dropdown.Header>
                                    
                                    <Dropdown.Divider />
                                    
                                    <Dropdown.Item href="/user" className="dropdown-item-custom">
                                        <FaUserCircle className="dropdown-item-icon me-3" />
                                        <div>
                                            <div>Profile Settings</div>
                                            <small className="text-muted">Manage your account</small>
                                        </div>
                                    </Dropdown.Item>
                                    
                                    <Dropdown.Item href="/books" className="dropdown-item-custom">
                                        <FaBook className="dropdown-item-icon me-3" />
                                        <div>
                                            <div>My Books</div>
                                            <small className="text-muted">View your books</small>
                                        </div>
                                    </Dropdown.Item>
                                    
                                    <Dropdown.Item href="#" className="dropdown-item-custom">
                                        <FaCog className="dropdown-item-icon me-3" />
                                        <div>
                                            <div>Settings</div>
                                            <small className="text-muted">App preferences</small>
                                        </div>
                                    </Dropdown.Item>
                                    
                                    <Dropdown.Divider />
                                    
                                    <Dropdown.Item 
                                        onClick={logout} 
                                        className="dropdown-item-custom logout-item"
                                    >
                                        <FaSignOutAlt className="dropdown-item-icon me-3" />
                                        <div>
                                            <div>Logout</div>
                                            <small className="text-muted">Sign out from system</small>
                                        </div>
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </React.Fragment>
    );
}

export default PortalNavbar;